import { Product } from './../../../../../../../models/product.model';
import { Component, OnInit } from '@angular/core';
import { IProduct } from '../../../../../../../models/product.model';
import { Router } from '@angular/router';
import { FormBuilder, FormControl } from '@angular/forms';
import { EncryptionService } from '../../../../../../../services/EncryptionService';
import { ProductService } from '../../../../../../../services/product.service';
import { BsModalService } from 'ngx-bootstrap/modal';
import { SharedFonctionsService } from '../../../../../../../services/shared-fonctions.service';
import { environment } from '../../../../../../../environments/environment';
import { IService, Service } from '../../../../../../../models/service.model';
import Swal from 'sweetalert2';
import * as XLSX from "xlsx";
import { Location } from '@angular/common';
import { VariantService } from '../../../../../../../services/variant.service';
import { ISubProduct, SubProduct } from '../../../../../../../models/subProduct.model';
@Component({
  selector: 'app-variante',
  templateUrl: './variante.component.html',
  styleUrls: ['./variante.component.scss']
})
export class VarianteComponent implements OnInit {
  url_photo:any;
  variants: ISubProduct[] = [];
  variant: ISubProduct;
  variantsTmp: ISubProduct[] =[];
  filtred:ISubProduct[]=[];
  filter = false;
  allProduct:ISubProduct[]=[];
  pageNumber: number = 1;
  pageSize: number = 10;
  totalItems :any;

  p = 1;
  search: any;

  sharedIdProd : any;
  sharedINameProd : String;
  constructor(private router:Router,private productService: ProductService,private fb: FormBuilder,
              private variantService: VariantService,private encryptionService: EncryptionService,
              private sharedSevice: SharedFonctionsService, private location: Location) { }

  ngOnInit(): void {
    this.url_photo=environment.url_photo;
    this.sharedIdProd = this.sharedSevice.sharedProdIdPartage;
    this.sharedINameProd = this.sharedSevice.sharedProdNamePartage;
    if(this.sharedIdProd == undefined || this.sharedIdProd == null) {
      let prodid = window.localStorage.getItem("sharedProdId!#");
      let prodname = window.localStorage.getItem("sharedProdName!#");
      if(prodid != null && prodid != undefined){
        let decr = this.encryptionService.decryptionAES(prodid);
        let decr1 = this.encryptionService.decryptionAES(prodname);
        this.sharedIdProd = decr;
        this.sharedINameProd = decr1;
      }
    }
    this.loadProduct();
  }

  dateForm = this.fb.group({
    beginDate: new FormControl(''),
    endDate: new FormControl('')
  })

  loadProduct = () => {
    this.allProduct= [];
    this.filtred = [];
    if(this.sharedIdProd){
      this.variantService.allSubProductsOfUser(this.sharedIdProd, this.pageNumber-1, this.pageSize).subscribe((data: any) => {
        this.variants = data;
        this.variantsTmp = data;
        this.totalItems = data.length;
       // console.log(this.variants);
      })
    }
  };

  raiseTableSize(event: any) {
    this.pageSize = event.target.value;
    this.loadProduct();
  }

  currentSection: string = 'mesProduits';
  toggleSection(section: string) {
    this.currentSection = section;
  }

  detailsProduit(prod:IProduct) {
    // this.modalRef = this.modalService.show(DetailsProduitListComponent,
    //   {
    //     initialState:{prod},
    //     backdrop:false,
    //     ignoreBackdropClick:true
    //   });
    // this.modalRef.content.saveEvent.subscribe((resp:any)=>this.loadProduct())
  }

  searchProducts($event: KeyboardEvent) {
    this.variants = this.variantsTmp.filter(value =>
      value?.name.toLowerCase().includes(this.search.toLowerCase().trim()) ||
      value?.subProductID.toLowerCase().includes(this.search.toLowerCase().trim()) ||
      (Number(this.search) === Number(value?.price)) ||
      (Number(this.search) === Number(value?.quantity)) ||
      (Number(this.search) === Number(value?.threshold))
    )
  }

  sortProductsByDate(products: Product[]): Product[] {
    return products.sort((a, b) => {
      if (a.createdAt && b.createdAt) {
        const dateA = new Date(a.createdAt);
        const dateB = new Date(b.createdAt);
        return dateB.getTime() - dateA.getTime();
      } else {
        return 0;
      }
    });
  }

  sortServiceByDate(services: Service[]): Service[] {
    return services.sort((a, b) => {
      if (a.createdAt && b.createdAt) {
        const dateA = new Date(a.createdAt);
        const dateB = new Date(b.createdAt);
        return dateB.getTime() - dateA.getTime();
      } else {
        return 0;
      }
    });
  }


  boutiquePage()
  {
    this.router.navigate(["/boutique"]).then(() => {
      // window.location.reload();
    });
  }

  deleteVariant(prod:ISubProduct){
    Swal.fire({
      title: 'Voulez-vous vraiment supprimer ce modèle de produit ?',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonText: 'Non',
      confirmButtonText: 'Oui'
    }).then((result) => {
      if (result.isConfirmed) {
        this.variantService.deleteSubProduct(prod).subscribe(
          rs=> {
            Swal.fire({
              position: 'top-end',
              icon: 'success',
              title: 'Votre produit est supprimé de la liste avec succès.',
              showConfirmButton: false,
              timer: 1500
            });
            this.loadProduct();
            this.reloadComponent();
          }, error => {
            // console.log(error);
            Swal.fire({
              position: 'top-end',
              icon: 'error',
              title: error.error.errorMessage,
              showConfirmButton: false,
              timer: 4500
            })
          }
        )
      }
    })

  }


  detailsService(serv:IService){
    // this.modalRef = this.modalService.show(DetailsServiceComponent,
    //   {
    //     initialState:{serv},
    //     backdrop:false,
    //     ignoreBackdropClick:true
    // });
  }

  reloadComponent() {
    let currentUrl = this.router.url;
    this.router.routeReuseStrategy.shouldReuseRoute = () => false;
    this.router.onSameUrlNavigation = 'reload';
    this.router.navigate([currentUrl]);
  }

  ascendingOrderByProductName: boolean = true;
  sortByProductName(){
    this.variants.sort((a, b) => {
      const nameA = a.name.toLowerCase();
      const nameB = b.name.toLowerCase();

      if(this.ascendingOrderByProductName){
        return nameA.localeCompare(nameB);
      }else {
        return nameB.localeCompare(nameA);
      }
    })
    this.ascendingOrderByProductName = !this.ascendingOrderByProductName;
  }

  ascendingOrderRef: boolean = true;
  sortByProductReference() {
    this.variants.sort((a, b) => {
      const nameA = a.productID;
      const nameB = b.productID;

      if(this.ascendingOrderRef){
        return nameA.localeCompare(nameB);
      }else {
        return nameB.localeCompare(nameA);
      }
    })
    this.ascendingOrderRef = !this.ascendingOrderRef;
  }

  ascendingOrderByCreatedDate: boolean = true;
  sortByCreatedDate() {
    this.variants.sort((a, b) => {
      const dateA = new Date(a.createdAt);
      const dateB = new Date(b.createdAt);
      if(this.ascendingOrderByCreatedDate){
        return dateA.getTime() - dateB.getTime();
      }else{
        return dateB.getTime() - dateA.getTime();
      }
    })
    this.ascendingOrderByCreatedDate = !this.ascendingOrderByCreatedDate;
  }

  ascendingCategory: boolean = true;
  sortByCategory() {
    // this.variants.sort((a, b) => {
    //   const nameA = a.category.name;
    //   const nameB = b.category.name;
    //   if(this.ascendingCategory){
    //     return nameA.localeCompare(nameA);
    //   }else{
    //     return nameB.localeCompare(nameA);
    //   }
    // })
    // this.ascendingOrderPhoneNumber = !this.ascendingOrderPhoneNumber;
  }

  ascendingOrderByCountryName: boolean = true;
  sortByShopSellerCountryName(){
    // this.variants.sort((a, b) => {
    //   const nameA = a.shop.city?.country.iso.toLowerCase();
    //   const nameB = b.shop.city?.country.iso.toLowerCase();

    //   if(this.ascendingOrderByCountryName){
    //     return nameA.localeCompare(nameB);
    //   }else {
    //     return nameB.localeCompare(nameA);
    //   }
    // })
    // this.ascendingOrderByCountryName = !this.ascendingOrderByCountryName;
  }

  ascendingOrderByCityName: boolean = true;
  sortByShopSellerCityName(){
    // this.variants.sort((a, b) => {
    //   const nameA = a.shop.city?.name.toLowerCase();
    //   const nameB = b.shop.city?.name.toLowerCase();

    //   if(this.ascendingOrderByCountryName){
    //     return nameA.localeCompare(nameB);
    //   }else {
    //     return nameB.localeCompare(nameA);
    //   }
    // })
    // this.ascendingOrderByCountryName = !this.ascendingOrderByCountryName;
  }

  ascendingOrderPhoneNumber: boolean = true;
  sortByPhoneNumber() {
    this.variants.sort((a, b) => {
      const mobileA = "a";
      const mobileB = "b";
      if(this.ascendingOrderPhoneNumber){
        return mobileA.localeCompare(mobileB);
      }else{
        return mobileB.localeCompare(mobileA);
      }
    })
    this.ascendingOrderPhoneNumber = !this.ascendingOrderPhoneNumber;
  }



  exportPostToExelFile(filename: string) {
    const data = document.getElementById('tab-post');
    const ws: XLSX.WorkSheet =XLSX.utils.table_to_sheet(data);

    const wb: XLSX.WorkBook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');

    /* save to file */
    XLSX.writeFile(wb, filename);
  }

  goBack(): void {
    this.location.back();
  }

  beginDateVal: any = null;
  displayErrorMessage: boolean = false;
  getBeginDate(event: any) {
    this.beginDateVal = event.target.value;
    if(this.beginDateVal != null){
      this.disableEndDate = false;
      if(this.beginDateVal > this.endDateVal){
        this.displayErrorMessage = true;
      }else {
        this.displayErrorMessage = false;
      }
    }
  }

  endDateVal: any = null;
  disableEndDate: boolean = true;
  getEndDate(event: any) {
    this.endDateVal = event.target.value;
   // console.log(this.endDateVal);
    if(this.beginDateVal > this.endDateVal){
      this.displayErrorMessage = true;
    }else{
      this.displayErrorMessage = false;
    }
  }

  refresh() {
    this.loadProduct();
    this.dateForm.patchValue({
      beginDate: '',
      endDate: ''
    })
  }

  filterByDate() {
    const beginDate = new Date(this.dateForm.get('beginDate').value).toISOString();
    const endDate = new Date(this.dateForm.get('endDate').value).toISOString();
    // console.log("Date sélectionnée")
    // console.log('beginDate:', beginDate);
    // console.log('endDate:', endDate);
    if(!beginDate || !endDate) {
      Swal.fire({
        position: 'top-end',
        icon: 'error',
        title: 'Veuillez renseigner la date de début et la date de fin',
        showConfirmButton: false,
        timer: 3500
      });
      return;
    }else{
      this.variantService.getKahpooShopsSubProductByDate(this.sharedIdProd, beginDate, endDate).subscribe(data =>{
        this.variants = data;
        this.variantsTmp = data;
        this.totalItems = data.length;
       // console.log("this.variants : "+this.variants);
      });
    }
  }

  subProductDetails(p: SubProduct){
    this.variant = p;
    // console.log("Variante sélectionnée...");
    // console.log(this.variant)
  }

  selected: boolean = false;
  imageName: string | undefined = '';
  getUrlPhoto() {
    this.imageName = this.variant?.photo;
    if(this.imageName != null || this.imageName != undefined){
      this.selected = true;
    }else {
      this.selected = false;
    }
  }

  getUrlPhoto1() {
    if(this.variant?.photo1)
    this.imageName = this.variant?.photo1;
    if(this.imageName != null || this.imageName != undefined){
      this.selected = true;
    }else {
      this.selected = false;
    }
  }

  getUrlPhoto2() {
    if(this.variant?.photo2)
    this.imageName = this.variant?.photo2;
    if(this.imageName != null || this.imageName != undefined){
      this.selected = true;
    }else {
      this.selected = false;
    }
  }
}

